import { render, staticRenderFns } from "./storeProceedsType.vue?vue&type=template&id=020274e1&scoped=true&"
import script from "./storeProceedsType.vue?vue&type=script&lang=js&"
export * from "./storeProceedsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020274e1",
  null
  
)

export default component.exports